export function wrap(value: number, min: number, max: number): number {
  return ((((value - min) % (max - min)) + (max - min)) % (max - min)) + min;
}
